import { render, staticRenderFns } from "./DeliveryNoteModal.vue?vue&type=template&id=f8b37bec&scoped=true"
import script from "./DeliveryNoteModal.vue?vue&type=script&lang=ts"
export * from "./DeliveryNoteModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8b37bec",
  null
  
)

export default component.exports